export const READ_MORE_MS_DELAY = 300;
export const CLUSTERED_MARKERS_PER_ITERATION = 2000;
export const ACCEPT_IMAGE_FILETYPES = 'image/jpeg,image/png';
export const ACCEPT_ATTACHMENT_FILETYPES =
  'application/pdf,image/jpeg,image/png,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain';
export const PAGE_CUSTOMIZABLE_PREFIX = 'PAGE_CUSTOMIZABLE_';

/**
 * @description Ruby's max integer. Used to validate the price.
 * @see app/validators/price_validator.rb
 */
export const RUBY_PRICE_MAX_INTEGER = 21474836;

/**
 * ActiveModel::Type::Integer with limit 4 bytes
 *
 * It's a signed 4-byte integer (32-bit).
 *
 * Maximum value: 2³¹ - 1 = 2,147,483,647
 * Minimum value: -2³¹ = -2,147,483,648
 *
 * Range: -2,147,483,648 to 2,147,483,647
 */
export const RUBY_INTEGER_32BIT_MAX = 2147483647;
